import { render, staticRenderFns } from "./wf-document-details-display.vue?vue&type=template&id=a4dbbd80&scoped=true&"
import script from "./wf-document-details-display.vue?vue&type=script&lang=ts&"
export * from "./wf-document-details-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-document-details-display.vue?vue&type=style&index=0&id=a4dbbd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dbbd80",
  null
  
)

export default component.exports